// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__05ZUt","addBtnContainer":"AddDetails_addBtnContainer__1MJ4e"};